import {
  HeadingTitle,
  SubHeadingTitle,
  Image,
} from "../../../components/shared/index";
import styles from "./aboutus.module.css";
import { teams } from "../../../constants/teams";

const Teams = () => {
  return (
    <section className={styles.teams__wrapper}>
      <HeadingTitle
        text="our team"
        style={styles.teams_heading} />

      <div className={styles.teams} >
        {teams?.map((item) => {
          return (
            <div className={styles.team__card} key={item?.id}>
              <Image
                src={item?.imageUrl}
                className={styles.team__image}
                alt={item?.name}
              />

              <HeadingTitle
                text={item?.name}
                style={styles.team__name}
              />
              <SubHeadingTitle
                subTitle={item?.designation}
                style={styles.team__designation}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Teams;